import { addDoc, getDocs, deleteDoc, collection, query, where, doc } from "firebase/firestore";
import { Post as IPost } from "../home/Home";
import { auth, db } from "../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../App";
import "./Post.css";

interface Props {
  post: IPost;
  refreshPosts?: () => void;
}
interface Like {
  userId: string;
  postId: string;
  likeId: string;
}

export const Post = (props: Props) => {
  const { post, refreshPosts } = props;
  const [user, loading, error] = useAuthState(auth);
  const [likes, setLikes] = useState<Like[] | null>(null);
  const [authWarningVisible, setAuthWarningVisible] = useState<boolean>(false);
  const navigate = useNavigate();
  const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);

  const { setSelectedUsername } = useContext(AppContext);
  const { setSelectedUserId } = useContext(AppContext);
  const { setSelectedPostId } = useContext(AppContext);

  const likesRef = collection(db, "post-likes");

  const addLike = async () => {
    try {
      if (user) {
        const newDoc = await addDoc(likesRef, { userId: user?.uid, postId: post.id });
        setLikes(prev =>
          prev
            ? [...prev, { userId: user?.uid, postId: post.id, likeId: newDoc.id }]
            : [{ userId: user?.uid, postId: post.id, likeId: newDoc.id }]
        );
      } else {
        setAuthWarningVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeLike = async () => {
    try {
      if (user) {
        const likesToDeleteQuery = query(likesRef, where("postId", "==", post.id), where("userId", "==", user?.uid));
        const likeToDeleteData = await getDocs(likesToDeleteQuery);
        const likeId = likeToDeleteData.docs[0].id;
        const likeToDelete = doc(db, "post-likes", likeId);
        await deleteDoc(likeToDelete);
        setLikes(prev => prev && prev.filter(like => like.likeId !== likeId));
      } else {
        setAuthWarningVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deletePost = async () => {
    try {
      setShowConfirmDelete(false);
      if (user?.uid != post.userId) return;
      const postToDelete = doc(db, "posts", post.id);
      await deleteDoc(postToDelete);
      refreshPosts && refreshPosts();
    } catch (error) {
      console.log(error);
    }
  };

  const editPost = async () => {
    setSelectedPostId(post.id);
    console.log(post.id);
    navigate("/editpost");
  };

  const userHasLikedPost = likes?.find(like => like.userId === user?.uid);

  const likesDoc = query(likesRef, where("postId", "==", post.id));

  const getLikes = async () => {
    const data = await getDocs(likesDoc);
    setLikes(data.docs.map(doc => ({ userId: doc.data().userId, postId: post.id, likeId: doc.id })));
  };
  const goToUsersPosts = () => {
    if (user?.uid === post.userId) {
      navigate("/myposts");
      return;
    }
    setSelectedUsername(post.username);
    setSelectedUserId(post.userId);
    navigate("/userpage");
  };

  useEffect(() => {
    getLikes();
  }, []);

  return (
    <>
      <div className='card mt-3'>
        {/* <img src='...' className='card-img-top' alt='...' /> */}
        {user?.uid === post.userId && (
          <div className='editButtons'>
            <button className='btn btn-primary mx-2 p-1 opacity-75' onClick={editPost}>
              Edit
            </button>
            {showConfirmDelete ? (
              <>
                <button className='btn btn-danger mx-2 p-1 opacity-75' onClick={deletePost}>
                  Confirm Delete
                </button>
                <button className='btn btn-success p-1 opacity-75' onClick={() => setShowConfirmDelete(false)}>
                  Cancel
                </button>
              </>
            ) : (
              <button className='btn btn-danger mx-2 p-1 opacity-75' onClick={() => setShowConfirmDelete(true)}>
                Delete
              </button>
            )}
          </div>
        )}
        <div className='card-body px-0 pt-3 pb-1'>
          <div className='d-flex justify-items-start px-3'>
            <h5 className='card-title fw-bolder text-start'>{post.title}</h5>
          </div>
          <div className='d-flex justify-items-start px-3 mb-3 py-3'>
            <p className='card-text text-start'>{post.description}</p>
          </div>
          <div className='card-footer pt-1 pb-0 mb-1 d-flex flex-row justify-content-between align-items-center'>
            <div className=''>
              <button
                onClick={user ? (userHasLikedPost ? removeLike : addLike) : () => setAuthWarningVisible(true)}
                className='btn btn-outline-warning mx-2 p-1'>
                {userHasLikedPost ? <>&#128078;</> : <>&#128077;</>}
              </button>
              <small>
                {likes?.length && likes?.length > 0 ? likes?.length : 0} {likes?.length === 1 ? "Like" : "Likes"}
              </small>
              <button className='btn'>
                <small className='mx-2 fw-bolder' onClick={goToUsersPosts}>
                  @{post.username}
                </small>
              </button>
            </div>

            <div>
              <button
                className='btn btn-dark mx-2 p-1 opacity-75'
                onClick={() => {
                  setSelectedPostId(post.id);
                  navigate("/comments");
                }}>
                Comments
              </button>
            </div>
          </div>
        </div>
      </div>
      {authWarningVisible && (
        <div className='alert alert-danger mx-auto mt-1 w-50 py-2 fw-bolder d-flex justify-content-between align-items-center'>
          <span>Please log in to interact with posts</span>
          <button className='btn btn-close ms-2 p-0' onClick={() => setAuthWarningVisible(false)}></button>
        </div>
      )}
    </>
  );
};
